const parentWindow = window.parent;
window._wq = window._wq || [];
window._wq.push( {
  id: '_all',
  onReady: function ( video ) {
    const metadata = ( () => {
      const isLegacyVideo = video._duration === undefined;
      return {
        duration: isLegacyVideo ? video.data.media.duration : video._duration,
        name: isLegacyVideo ? video.data.media.name : video._name,
        hashid: isLegacyVideo ? video.hashedId : video._hashedId,
        src: isLegacyVideo ? `https://fast.wistia.net/embed/iframe/${video.hashedId}` : video.src,
      };
    } )();

    // Track progress checkpoints
    const progressCheckpoints = [
      {percent: 25, tracked: false},
      {percent: 50, tracked: false},
      {percent: 75, tracked: false},
      {percent: 90, tracked: false},
    ];
    let videoStartTracked = false;

    // Push events to dataLayer with consistent format
    const trackEvent = ( eventType, additionalData = {} ) => {
      if ( !window.dataLayer ) return;

      window.dataLayer.push( {
        event: eventType,
        video_provider: 'wistia',
        video_title: metadata.name,
        video_url: metadata.src,
        ...additionalData,
      } );
    };

    // Track video start
    video.bind( 'play', () => {
      if ( !videoStartTracked ) {
        trackEvent( 'video_start' );
        videoStartTracked = true;
        parentWindow.postMessage( 'videoPlay', '*' ); // NOSONAR
      }
    } );

    // Track progress milestones
    video.bind( 'timechange', ( currentTime ) => {
      const playPercentage = Math.round( ( currentTime / metadata.duration ) * 100 );

      // Check each checkpoint efficiently
      for ( const checkpoint of progressCheckpoints ) {
        if ( playPercentage >= checkpoint.percent && !checkpoint.tracked ) {
          trackEvent( 'video_progress', {
            video_current_time: currentTime,
            video_duration: metadata.duration,
            video_percent: checkpoint.percent,
          } );
          checkpoint.tracked = true;
        }
      }
    } );

    // Track video completion
    video.bind( 'end', () => {
      trackEvent( 'video_completed', {
        video_current_time: metadata.duration,
        video_duration: metadata.duration,
        video_percent: 100,
      } );
    } );

    // Start playback
    video.play();
  },
} );